/// <amd-module name="TFS/Admin/Groups/Common/Redux/GroupsViewSelectors" />
import { GroupsNavType, IPermissionPage } from "TFS/Admin/Groups/Common/Constants";
import { CustomGraphMember, IOrganizationGroupsAwareState, PermissionsGroup } from "TFS/Admin/Groups/Common/Contracts";
import { GraphServicePrincipal, GraphUser } from "VSS/Platform/Contracts/Graph";
import { IIdentity } from "VSSUI/IdentityPicker";

export function getSelectedGroup(state: IOrganizationGroupsAwareState): PermissionsGroup | undefined {
    if (!state || !state.pageState) {
        return undefined;
    }

    return state.pageState.selectedGroup;
}

export function getSelectedNavType(state: IOrganizationGroupsAwareState): GroupsNavType {
    if (!state || !state.pageState) {
        return GroupsNavType.Default;
    }

    return state.pageState.selectedNavType;
}

export function canEditProjectLevelInformation(state: IOrganizationGroupsAwareState): boolean {
    if (!state || !state.pageState) {
        return false;
    }
    return state.pageState.canEditProjectLevelInformation;
}

export function getSelectedUser(state: IOrganizationGroupsAwareState): GraphUser | undefined {
    if (!state || !state.pageState) {
        return undefined;
    }

    return state.pageState.selectedUser;
}

export function getSelectedMember(state: IOrganizationGroupsAwareState): CustomGraphMember | undefined {
    if (!state || !state.pageState) {
        return undefined;
    }

    return state.pageState.selectedMember;
}

export function getSelectedServicePrincipal(state: IOrganizationGroupsAwareState): GraphServicePrincipal | undefined {
    if (!state || !state.pageState) {
        return undefined;
    }

    return state.pageState.selectedServicePrincipal;
}

export function setFilterPlaceholder(state: IOrganizationGroupsAwareState): string | undefined {
    if (!state || !state.pageState) {
        return undefined;
    }

    return state.pageState.filterPlaceHolder;
}

export function getScopeDescriptor(state: IOrganizationGroupsAwareState): string | undefined {
    if (!state || !state.pageState) {
        return undefined;
    }

    return state.pageState.scopeDescriptor;
}

export function isCollectionNavigationAllowed(state: IOrganizationGroupsAwareState): boolean {
    if (!state || !state.pageState) {
        return false;
    }

    return state.pageState.isCollectionNavigationAllowed;
}

export function getIsTeamsPageFlag(state: IOrganizationGroupsAwareState): boolean | undefined {
    if (!state || !state.pageState) {
        return undefined;
    }

    return state.pageState.isTeamsPage;
}

export function isProjectScope(state: IOrganizationGroupsAwareState): boolean {
    if (!state || !state.groupsState) {
        return false;
    }

    return state.groupsState.isProjectScope;
}

export function getUpdatedAvatarUrl(state: IOrganizationGroupsAwareState): string | undefined {
    if (!state || !state.pageState) {
        return undefined;
    }

    return state.pageState.updatedAvatarUrl;
}

export function getToMarkPermissionsTTI(state: IOrganizationGroupsAwareState): boolean {
    if (!state || !state.pageState) {
        return false;
    }

    return state.pageState.toMarkPermissionsTTI;
}

export function isURLRedirect(state: IOrganizationGroupsAwareState): boolean {
    if (!state || !state.pageState) {
        return false;
    }

    return state.pageState.isURLRedirect;
}

export function showAddMemberPanel(state: IOrganizationGroupsAwareState): boolean {
    if (!state || !state.pageState) {
        return false;
    }

    return state.pageState.showAddMemberPanel;
}

export function getPcaGroup(state: IOrganizationGroupsAwareState): PermissionsGroup | undefined {
    if (!state || !state.pageState) {
        return undefined;
    }

    return state.pageState.pcaGroup;
}

export function getInvalidMembers(state: IOrganizationGroupsAwareState): IIdentity[] {
    if (!state || !state.pageState || !state.pageState.invalidMembers) {
        return [];
    }

    return state.pageState.invalidMembers;
}

export function getValidMembers(state: IOrganizationGroupsAwareState): IIdentity[] {
    if (!state || !state.pageState || !state.pageState.validMembers) {
        return [];
    }

    return state.pageState.validMembers;
}

export function getPermissionPage(state: IOrganizationGroupsAwareState): IPermissionPage | undefined {
    if (!state || !state.pageState) {
        return IPermissionPage.Organization;
    }

    return state.pageState.permissionPage;
}
